import Phaser from "phaser";
import { DatabaseHandle } from "./database/database";
import { SceneName, GAME_VARIABLES } from "./constants";
import TurnBasedInputPlugin from "./plugins/TurnBasedInputPlugin";
import StartScene from "./gameScene";
import { PlayerState } from "./state/playerStateJson";
import Player, { Dir } from "./entities/Player";
import animationData from "./artConfig.json";
import levelUnlockingSystem, {
  levelChunkSequence,
} from "./worldMap/levelUnlockingSystem";
import { OneOffFx } from "./art/FX/oneOffFx";
import { EntityKind } from "./state/entityKinds";
import { SoundPlayer } from "./sounds/SoundPlayer";
import { WorldMapGradientBacker } from "./art/FX/backgrounds/WorldMapGradientBacker";
import levelData from "./../../static/assets/levels/levelsDump.json";
const Xoffset = 34;
const Yoffset = 34;
const worldMapChangeChunkTime = 500;

const globalRandom = new Phaser.Math.RandomDataGenerator("lol");

function sendUnlockChunkEvent(chunk: number) {
  // Google analytics
  if (typeof window.ga === "function") {
    window.ga(
      "send",
      "event",
      "WorldMapScene",
      "unlockedChunk",
      undefined,
      chunk
    );
  }
}

interface ILevelSelection {
  levelKey: string;
  number: string;
  locked: boolean;
  displayName: string | undefined;
}
let counter = 0;

const MAP_CELL_SIZE = 21;

class LevelShadow {
  private scene: WorldMapScene;
  private topRow: Phaser.GameObjects.Sprite[];
  private topRow2: Phaser.GameObjects.Sprite[];
  private bottomRow: Phaser.GameObjects.Sprite[];
  private bottomRow2: Phaser.GameObjects.Sprite[];
  constructor(scene: WorldMapScene) {
    this.scene = scene;
    const topRowX = Xoffset;
    const topRoxY = Yoffset - MAP_CELL_SIZE;
    const createSprite = (x, y) => {
      return scene.add
        .sprite(x, y, "atlas", "big_tile/big_tile_backer_hint")
        .setDepth(1);
    };
    // Todo create this pretty tricky scrolling effect.
    this.topRow = Array.from(new Array(3)).map((_, i) =>
      createSprite(topRowX + MAP_CELL_SIZE * i, topRoxY)
    );
    this.topRow2 = Array.from(new Array(3)).map((_, i) =>
      createSprite(topRowX + MAP_CELL_SIZE * i, topRoxY)
    );
    this.bottomRow = Array.from(new Array(3)).map((_, i) =>
      createSprite(0, 0)
        .setFlipY(true)
        .setPosition(topRowX + MAP_CELL_SIZE * i, 76 + MAP_CELL_SIZE * 2)
    );
    this.bottomRow2 = Array.from(new Array(3)).map((_, i) =>
      createSprite(0, 0)
        .setFlipY(true)
        .setPosition(topRowX + MAP_CELL_SIZE * i, 76 + MAP_CELL_SIZE * 2)
    );

    if (this.scene.currentChunk === 0) {
      this.bottomRow.forEach((s) => {
        s.alpha = 0;
      });
      this.bottomRow2.forEach((s) => {
        s.alpha = 0;
      });
    } else if (this.scene.currentChunk === 5) {
      this.topRow.forEach((s) => {
        s.alpha = 0;
      });
      this.topRow2.forEach((s) => {
        s.alpha = 0;
      });
    }

    // TODO - hide based on current chunk
    scene.events.on("moveUpMap", () => {
      // Bottom go down
      if (this.scene.currentChunk !== 1) {
        this.scene.add.tween({
          targets: this.bottomRow,
          y: { from: 76 + MAP_CELL_SIZE * 2, to: 76 + MAP_CELL_SIZE * 3 },
          alpha: { from: 1, to: 0 },
          duration: worldMapChangeChunkTime,
          ease: "Sine.easeIn",
        });
      }
      this.scene.add.tween({
        targets: this.bottomRow2,
        y: { from: 76 + MAP_CELL_SIZE, to: 76 + MAP_CELL_SIZE * 2 },
        alpha: { from: 0.1, to: 1 },
        duration: worldMapChangeChunkTime,
        ease: "Sine.easeIn",
      });
      this.scene.add.tween({
        targets: this.topRow,
        y: { from: topRoxY, to: topRoxY + MAP_CELL_SIZE },
        alpha: { from: 1, to: 0 },
        duration: worldMapChangeChunkTime,
        ease: "Sine.easeIn",
      });
      if (this.scene.currentChunk !== 5) {
        this.scene.add.tween({
          targets: this.topRow2,
          y: { from: topRoxY - MAP_CELL_SIZE, to: topRoxY },
          alpha: { from: 0, to: 1 },
          duration: worldMapChangeChunkTime,
          ease: "Sine.easeIn",
        });
      } else {
        this.scene.time.delayedCall(0, () => {
          this.topRow2.forEach((s) => {
            s.alpha = 0;
          });
        });
      }
    });

    scene.events.on("moveDownMap", () => {
      // DONE
      this.scene.add.tween({
        targets: this.bottomRow,
        y: { from: 76 + MAP_CELL_SIZE * 2, to: 76 + MAP_CELL_SIZE },
        alpha: { from: 1, to: 0 },
        duration: worldMapChangeChunkTime,
        ease: "Sine.easeIn",
      });
      // DONE:
      if (this.scene.currentChunk !== 0) {
        this.scene.add.tween({
          targets: this.bottomRow2,
          y: { from: 76 + MAP_CELL_SIZE * 3, to: 76 + MAP_CELL_SIZE * 2 },
          alpha: { from: 0.1, to: 1 },
          duration: worldMapChangeChunkTime,
          ease: "Sine.easeIn",
        });
      } else {
        this.scene.time.delayedCall(0, () => {
          this.bottomRow2.forEach((s) => {
            s.alpha = 0;
          });
        });
      }

      // DONE
      if (this.scene.currentChunk !== 4) {
        this.scene.add.tween({
          targets: this.topRow,
          y: { from: topRoxY, to: topRoxY - MAP_CELL_SIZE },
          alpha: { from: 1, to: 0 },
          duration: worldMapChangeChunkTime,
          ease: "Sine.easeIn",
        });
      }
      // DONE
      this.scene.add.tween({
        targets: this.topRow2,
        y: { from: topRoxY + MAP_CELL_SIZE, to: topRoxY },
        alpha: { from: 0, to: 1 },
        duration: worldMapChangeChunkTime,
        ease: "Sine.easeIn",
      });
    });
  }
}

class LevelNameUI {
  private bitmapText: Phaser.GameObjects.BitmapText;
  private _travelText: string;
  private scene: Phaser.Scene;
  constructor(scene: Phaser.Scene) {
    this.bitmapText = scene.add.bitmapText(
      128 / 2,
      4,
      "bitPixelFont",
      "",
      0,
      1
    );
    this.scene = scene;
    this._travelText = "";
    this.bitmapText.setOrigin(0.5, 0.5);
    this.bitmapText.setDepth(1000);
  }

  public updateText() {
    let newText = this.bitmapText.text;
    for (let i = 0; i < this.bitmapText.text.length; i++) {
      const character = this.bitmapText.text[i];
      if (this._travelText[i] !== character) {
        if (Math.random() < 0.09) {
          newText =
            this.bitmapText.text.slice(0, i) +
            this._travelText[i] +
            this.bitmapText.text.slice(i + 1);
        } else if (Math.random() < 0.04) {
          newText =
            this.bitmapText.text.slice(0, i) +
            globalRandom.pick("*&,.+-!@#".split("")) +
            this.bitmapText.text.slice(i + 1);
        }
      }
    }
    this.bitmapText.text = newText;
  }

  public setText(v: string) {
    this._travelText = v;
    if (this._travelText.length > this.bitmapText.text.length) {
      const extraLetters =
        this._travelText.length - this.bitmapText.text.length;
      this.bitmapText.setText(
        this.bitmapText.text +
          Array.from(Array(extraLetters)).map((_) =>
            globalRandom.pick("*&,.+-!@#".split(""))
          )
      );
    } else if (this._travelText.length < this.bitmapText.text.length) {
      this.bitmapText.setText(
        this.bitmapText.text.slice(0, this._travelText.length)
      );
    }
  }
}

export class LevelSelection {
  public sprite: Phaser.GameObjects.Sprite;
  public levelTexture: Phaser.GameObjects.RenderTexture;
  private scene: Phaser.Scene;
  public chunkIdx: number;
  private worldMapReference: WorldMapScene;
  private moveChunkChecker: (dir: Dir) => boolean;
  public set x(v: number) {
    this.sprite.x = v * MAP_CELL_SIZE + Xoffset;
    this.backBloom.x = v * MAP_CELL_SIZE + Xoffset;
    this.levelTexture.x = v * MAP_CELL_SIZE + Xoffset + 1;
  }
  public set y(v: number) {
    this.sprite.y = v * MAP_CELL_SIZE + Yoffset;
    this.backBloom.y = v * MAP_CELL_SIZE + Yoffset;
    this.levelTexture.y = v * MAP_CELL_SIZE + Yoffset + 1;
  }

  public xIdx: number;
  public yIdx: number;

  public isCompleted: boolean;

  public data: ILevelSelection;
  private backBloom: Phaser.GameObjects.Sprite;
  constructor(
    scene: Phaser.Scene,
    data: ILevelSelection,
    x: number,
    y: number,
    chunkIdx: number,
    worldMapReference: WorldMapScene,
    moveChunkChecker: (dir: Dir) => boolean
  ) {
    this.moveChunkChecker = moveChunkChecker;
    this.worldMapReference = worldMapReference;
    this.chunkIdx = chunkIdx;
    this.scene = scene;
    this.xIdx = x;
    this.yIdx = y;

    this.isCompleted = false;

    this.data = data;
    this.sprite = scene.add.sprite(0, 0, "atlas", "big_tile/big_tile_backer");
    this.sprite.setDepth(10);

    this.levelTexture = scene.add.renderTexture(0, 0, 16, 16);
    this.levelTexture.setDepth(9);
    const blitter = scene.add.blitter(0, 0, "atlas", "paintlevel/emptypixel");
    blitter.setDepth(-1000);
    this.backBloom = scene.add.sprite(0, 0, "atlas", "back_light/back_light1");
    this.backBloom.setVisible(false);
    this.backBloom.setAlpha(0.2);
    this.backBloom.setDepth(-1);
    this.backBloom.setBlendMode(Phaser.BlendModes.ADD);
    this.backBloom.play(
      animationData.animations.back_light.key,
      true,
      globalRandom.integerInRange(1, 8)
    );
    const { doc: foundLevelDataDoc } = levelData.find(
      ({ key }) => key === data.levelKey
    );
    blitter.create(0, 0, "paintlevel/floorpixel");
    for (let i = 0; i < 16; i++) {
      for (let j = 0; j < 16; j++) {
        this.levelTexture.draw(blitter, i, j);
      }
    }
    for (const { x, y, kind, isOpposite } of foundLevelDataDoc.entities) {
      if (kind === EntityKind.Empty) {
        blitter.create(0, 0, "paintlevel/emptypixel");
        this.levelTexture.draw(blitter, x, y);
      }
      if (kind === EntityKind.StaticWall) {
        blitter.create(0, 0, "paintlevel/wallpixel");
        this.levelTexture.draw(blitter, x, y);
      }
      if (kind === EntityKind.Door) {
        if (isOpposite) {
          blitter.create(0, 0, "paintlevel/antidoorpixel");
        } else {
          blitter.create(0, 0, "paintlevel/doorpixel");
        }
        this.levelTexture.draw(blitter, x, y);
      }
    }

    this.sprite.setDataEnabled();
    this.sprite.setData("levelSelectionReference", this);

    this.x = x;
    this.y = y;

    this.update();
  }

  chunkChanged(from: number, to: number) {
    const distance = MAP_CELL_SIZE;
    if (from === this.chunkIdx) {
      if (from < to) {
        //Go down
        this.worldMapReference.add.tween({
          targets: [this.sprite, this.levelTexture],
          y: `+=${distance}`,
          alpha: 0,
          duration: worldMapChangeChunkTime,
          ease: "Sine.easeIn",
          onComplete: () => {
            this.sprite.y -= distance;
            this.levelTexture.y -= distance;
            this.update();
          },
        });
      } else {
        //Go up
        this.worldMapReference.add.tween({
          targets: [this.sprite, this.levelTexture],
          y: `-=${distance}`,
          alpha: 0,
          duration: worldMapChangeChunkTime,
          ease: "Sine.easeIn",
          onComplete: () => {
            this.sprite.y += distance;
            this.levelTexture.y += distance;
            this.update();
          },
        });
      }
    }

    if (to === this.chunkIdx) {
      if (from < to) {
        this.sprite.y -= distance;
        this.levelTexture.y -= distance;
        // Go down
        this.worldMapReference.add.tween({
          targets: [this.sprite, this.levelTexture],
          y: `+=${distance}`,
          alpha: { from: 0, to: 1 },
          duration: worldMapChangeChunkTime,
          ease: "Sine.easeIn",
          onStart: () => {
            this.setVisibility();
          },
          onComplete: () => {
            this.update();
          },
        });
      } else {
        this.sprite.y += distance;
        this.levelTexture.y += distance;
        this.worldMapReference.add.tween({
          targets: [this.sprite, this.levelTexture],
          y: `-=${distance}`,
          alpha: { from: 0, to: 1 },
          duration: worldMapChangeChunkTime,
          ease: "Sine.easeIn",
          onStart: () => {
            this.setVisibility();
          },
          onComplete: () => {
            this.update();
          },
        });
      }
    }
  }

  isAnAllowedDirection(dir: Dir) {
    return this.moveChunkChecker(dir);
  }

  update() {
    if (this.worldMapReference.currentChunk === this.chunkIdx) {
      this.sprite.alpha = 0.95;
      this.levelTexture.alpha = 1;
    } else {
      this.sprite.alpha = 0;
      this.levelTexture.alpha = 0;
    }
    if (this.isCompleted) {
      // Animating this in happens in transition into world map.
      this.sprite.alpha = 0;
    } else if (this.data.locked) {
      this.sprite.alpha = 1;
    }
    this.setVisibility();
  }

  setVisibility() {
    this.sprite.setVisible(
      this.worldMapReference.currentChunk === this.chunkIdx && !this.isCompleted
    );
    this.levelTexture.setVisible(
      this.worldMapReference.currentChunk === this.chunkIdx && !this.data.locked
    );
  }

  setBackLightVisibility() {
    if (
      this.worldMapReference.currentChunk === this.chunkIdx &&
      this.isCompleted
    ) {
      this.backBloom.setVisible(true);
    } else {
      this.backBloom.setVisible(false);
    }
  }

  markCompleted() {
    this.isCompleted = true;
    this.data.locked = false;
    this.update();
  }
}

export class WorldMapScene extends Phaser.Scene {
  // Contains the chunks, then 3 by 3 levels
  public currentChunk: number;
  private board: LevelSelection[][][];
  private cursor: Phaser.GameObjects.Sprite;
  private locationMap: Map<string, LevelSelection>;
  private levelNameUI: LevelNameUI;
  private worldMapGradient: WorldMapGradientBacker;
  constructor() {
    super(SceneName.MapScene);
    this.currentChunk = 0;
    this.board = Array.from(new Array(levelChunkSequence.length)).map((_) =>
      Array.from(new Array(3)).map((_) => Array.from(new Array(3)))
    );
    this.locationMap = new Map();
    window.scene = this;
  }

  async upwardsExplosionsUnlockChunk() {
    const topRowX = Xoffset;
    const topRoxY = Yoffset - MAP_CELL_SIZE;

    const explosionPatternUpArrow = [
      [[1, 2]],
      [
        [0, 2],
        [1, 1],
        [2, 2],
      ],
      [
        [0, 1],
        [1, 0],
        [2, 1],
      ],
      [
        [0, 0],
        [2, 0],
      ],
    ];

    for (const row of explosionPatternUpArrow) {
      await new Promise((resolve) => this.time.delayedCall(500, resolve));
      this.cameras.main.shake(100, 0.007);
      SoundPlayer.worldBoomSFX(this);
      for (const [x, y] of row) {
        OneOffFx.createFX(
          topRowX + x * MAP_CELL_SIZE,
          topRoxY + (y + 1) * MAP_CELL_SIZE,
          animationData.animations.circle_boom.key,
          this,
          () => {},
          { depth: 1 }
        );
      }
    }
    await new Promise((resolve) => this.time.delayedCall(1000, resolve));
  }

  async create() {
    SoundPlayer.registerScene(this);

    new LevelShadow(this);
    this.worldMapGradient = new WorldMapGradientBacker(this, this.currentChunk);
    this.worldMapGradient.changeSprite(this.currentChunk);
    this.cameras.main.flash(GAME_VARIABLES.MOVE_TIME_MS * 6, 0, 0, 0, true);

    GAME_VARIABLES.IS_RESTART = false;
    this.levelNameUI = new LevelNameUI(this);
    counter++;
    this.scene.add(
      `${SceneName.StartScene}-worldmap-${counter}`,
      StartScene,
      false
    );
    const turnBaseInput: TurnBasedInputPlugin = (this as any).myInput;
    this.events.on("transitionstart", () => {
      console.log("worldmapScene - transition Started");
      turnBaseInput.triggerForceDebounce();
    });
    this.events.on(
      "transitioncomplete",
      () => {
        this.time.delayedCall(50, async () => {
          // Creation has already run by this stage. Here we can do extra fun things :P
          // Handle extra animations for making stuff look good and appear :)
          if (PlayerState.justWonLevel) {
            const justCompletedLevel = this.locationMap.get(
              PlayerState.justWonLevel
            );
            if (justCompletedLevel?.sprite) {
              const { x, y } = justCompletedLevel.sprite;
              this.time.delayedCall(600, () => {
                justCompletedLevel.markCompleted();
              });
              await new Promise((resolve) => {
                this.time.delayedCall(400, () => {
                  this.cameras.main.shake(100, 0.007);
                  SoundPlayer.unlockLevelSFX(this);
                  OneOffFx.createFX(
                    x,
                    y,
                    animationData.animations.circle_boom.key,
                    this,
                    () => {},
                    { depth: 1 }
                  );
                });
                this.time.delayedCall(200, () => {
                  OneOffFx.createFX(
                    x,
                    y,
                    animationData.animations.tileCompletedFX.key,
                    this,
                    resolve,
                    undefined
                  );
                });
              });
              justCompletedLevel.markCompleted();
              if (
                levelUnlockingSystem.unlockLogic(async () => {
                  // TODO make a UI to show that the player should go up here.
                  for (const [key, level] of this.locationMap.entries()) {
                    level.data.locked = !levelUnlockingSystem.isLevelUnlocked(
                      key
                    );
                    level.update();
                  }
                })
              ) {
                await this.upwardsExplosionsUnlockChunk();

                this.cameras.main.flash(3000);
                SoundPlayer.chunkUnlockSFX(this);
                await new Promise((resolve) => {
                  sendUnlockChunkEvent(this.currentChunk + 1);
                  this.tryMoveUpChunk();
                  if (this.currentChunk >= 5) {
                    console.log("YOU WON THE GAME");
                    this.thankYouForPlaying();
                  }
                  this.time.delayedCall(1000, () => {
                    this.cursor.x = 8 + Xoffset + 1;
                    this.cursor.y = 8 + Yoffset + 1;
                    resolve();
                  });
                });
              }
            }
          }
          this.cursor.setVisible(true);
          turnBaseInput.removeForceDebounce();
        });
      },
      this
    );

    let cursor_x_start = 0;
    let cursor_y_start = 0;

    let i = 0;
    const worldMapJSON = this.cache.json.entries.get("worldMap");
    let index = 0;
    for (const chunkArray of Object.values<any>(worldMapJSON)) {
      for (let levelIdx = 0; levelIdx < chunkArray.length; levelIdx++) {
        const level = chunkArray[levelIdx];
        const x = Math.floor(levelIdx % 3);
        const y = Math.floor(levelIdx / 3);

        if (level.levelKey === "Overworld_pre") {
          cursor_x_start = x;
          cursor_y_start = y;
        }

        const levelNumber = index * 9 + (levelIdx + 1);
        const levelSelector = new LevelSelection(
          this,
          {
            levelKey: level.levelKey,
            number: levelNumber < 10 ? `0${levelNumber}` : `${levelNumber}`,
            locked: !levelUnlockingSystem.isLevelUnlocked(level.levelKey),
            displayName: level.displayName || "",
          },
          x,
          y,
          index,
          this,
          (dir: Dir) => {
            if (y === 0 && dir === Dir.Up) {
              return true;
            } else if (y === 2 && dir === Dir.Down) {
              return true;
            }
            return false;
          }
        );
        this.board[index][x][y] = levelSelector;
        this.locationMap.set(level.levelKey, levelSelector);
      }
      index++;
    }

    for (const completedLevels of PlayerState.levelsCompleted) {
      const getLevelData: LevelSelection | undefined = this.locationMap.get(
        completedLevels
      );
      if (!getLevelData) {
        continue;
      }
      if (PlayerState.justWonLevel === completedLevels) {
        continue;
      }
      getLevelData.markCompleted();
    }

    if (this.cursor === undefined || this.cursor.active === false) {
      console.log({ cursor_x_start, cursor_y_start });
      this.cursor = this.add.sprite(
        cursor_x_start * MAP_CELL_SIZE + 8 + Xoffset + 1,
        cursor_y_start * MAP_CELL_SIZE + 8 + Yoffset + 1,
        "atlas",
        "LevelSelector/level_cursor"
      );
      this.cursor.setDepth(20);
    }
    this.cursor.setVisible(PlayerState.justWonLevel === undefined);

    this.add.tween({
      targets: this.cursor,
      scale: { from: 1, to: 1.3 },
      yoyo: true,
      duration: 500,
      repeat: -1,
    });

    if (PlayerState.lastLevelEntered) {
      const lastCompletedLevel = this.locationMap.get(
        PlayerState.lastLevelEntered
      );
      if (lastCompletedLevel) {
        this.cursor.x =
          lastCompletedLevel.xIdx * MAP_CELL_SIZE + 8 + Xoffset + 1;
        this.cursor.y =
          lastCompletedLevel.yIdx * MAP_CELL_SIZE + 8 + Yoffset + 1;

        console.log({
          cursorX: lastCompletedLevel.xIdx,
          cursorY: lastCompletedLevel.yIdx,
        });
      }
    }
  }

  changeToCompletedState() {}

  async tryMoveUpChunk() {
    if (this.currentChunk >= 5) {
      console.log("top of list");
      return;
    }

    const input: TurnBasedInputPlugin = (this as any).myInput;
    input.triggerForceDebounce();
    this.time.delayedCall(worldMapChangeChunkTime, () => {
      input.removeForceDebounce();
    });
    this.currentChunk += 1;
    this.worldMapGradient.changeSprite(this.currentChunk);
    for (const levels of this.locationMap.values()) {
      levels.chunkChanged(this.currentChunk - 1, this.currentChunk);
    }

    this.events.emit("moveUpMap");

    const endY = this.cursor.y + MAP_CELL_SIZE * 2;
    this.add.tween({
      targets: this.cursor,
      y: `-=${MAP_CELL_SIZE * 2}`,
      alpha: { from: 1, to: 0 },
      duration: worldMapChangeChunkTime / 2,
      onComplete: () => {
        this.add.tween({
          targets: this.cursor,
          y: { from: 128 - MAP_CELL_SIZE, to: endY },
          alpha: { from: 0, to: 1 },
          duration: worldMapChangeChunkTime / 2,
        });
      },
    });
  }

  async tryMoveDownChunk() {
    if (this.currentChunk <= 0) {
      console.log("bottom of list");
      return;
    }
    const input: TurnBasedInputPlugin = (this as any).myInput;
    input.triggerForceDebounce();
    this.time.delayedCall(worldMapChangeChunkTime, () => {
      input.removeForceDebounce();
    });
    this.currentChunk -= 1;
    this.worldMapGradient.changeSprite(this.currentChunk);
    for (const levels of this.locationMap.values()) {
      levels.chunkChanged(this.currentChunk + 1, this.currentChunk);
    }
    this.events.emit("moveDownMap");

    const endY = this.cursor.y - MAP_CELL_SIZE * 2;
    this.add.tween({
      targets: this.cursor,
      y: `+=${MAP_CELL_SIZE * 2}`,
      alpha: { from: 1, to: 0 },
      duration: worldMapChangeChunkTime / 2,
      onComplete: () => {
        this.add.tween({
          targets: this.cursor,
          y: { from: MAP_CELL_SIZE, to: endY },
          alpha: { from: 0, to: 1 },
          duration: worldMapChangeChunkTime / 2,
        });
      },
    });
  }

  saveOutDataMap() {
    const result = {};
    for (const child of this.children.list) {
      if (child.type !== "Sprite") {
        continue;
      }
      const sprite = child as Phaser.GameObjects.Sprite;
      const levelData: LevelSelection = sprite.getData(
        "levelSelectionReference"
      );
      if (levelData === undefined) {
        continue;
      }
      result[levelData.data.levelKey] = {
        ...levelData.data,
        x: Math.floor(sprite.x / MAP_CELL_SIZE),
        y: Math.floor(sprite.y / MAP_CELL_SIZE),
      };
    }

    this.load.saveJSON(result, "worldMap.json");
  }

  thankYouForPlaying() {
    const text = this.add.text(64, 114, `Thank you\nfor playing!`, {
      fontFamily: "sins",
      fontSize: "16px",
      align: "center",
      color: "white",
    });
    text.setResolution(10);
    text.setOrigin(0.5);
  }

  update(time: number, deltaTime: number) {
    if (this.cursor === undefined) {
      return;
    }
    this.levelNameUI.updateText();
    const input: TurnBasedInputPlugin = (this as any).myInput;
    let xIdx = Math.floor((this.cursor.x - Xoffset) / MAP_CELL_SIZE);
    let yIdx = Math.floor((this.cursor.y - Yoffset) / MAP_CELL_SIZE);

    if (this.levelNameUI && this.board[this.currentChunk]?.[xIdx]?.[yIdx]) {
      const contents = this.board[this.currentChunk]?.[xIdx]?.[yIdx];
      if (this.board[this.currentChunk]?.[xIdx][yIdx]?.data?.locked) {
        this.levelNameUI.setText("LOCKED");
      } else {
        this.levelNameUI.setText(contents.data.displayName || "");
      }
    }

    if (
      input.isJustPressedUp &&
      this.board[this.currentChunk]?.[xIdx]?.[yIdx]?.isAnAllowedDirection(
        Dir.Up
      )
    ) {
      // Here we can go up a chunk
      this.tryMoveUpChunk();
      return;
    }
    if (
      input.isJustPressedDown &&
      this.board[this.currentChunk]?.[xIdx]?.[yIdx]?.isAnAllowedDirection(
        Dir.Down
      )
    ) {
      this.tryMoveDownChunk();
      return;
    }

    if (
      input.isJustPressedUp &&
      this.board[this.currentChunk]?.[xIdx]?.[yIdx - 1]
    ) {
      this.add.tween({
        targets: this.cursor,
        y: `-=${MAP_CELL_SIZE}`,
        yoyo: false,
        duration: GAME_VARIABLES.MOVE_TIME_MS - 20,
        repeat: 0,
        onComplete: () => {
          this.cursor.x = xIdx * MAP_CELL_SIZE + 8 + Xoffset + 1;
          this.cursor.y = (yIdx - 1) * MAP_CELL_SIZE + 8 + Yoffset + 1;
        },
      });
      SoundPlayer.clickSFX(this, 0.75);
    } else if (
      input.isJustPressedDown &&
      this.board[this.currentChunk]?.[xIdx]?.[yIdx + 1]
    ) {
      this.add.tween({
        targets: this.cursor,
        y: `+=${MAP_CELL_SIZE}`,
        yoyo: false,
        duration: GAME_VARIABLES.MOVE_TIME_MS - 20,
        repeat: 0,
        onComplete: () => {
          this.cursor.x = xIdx * MAP_CELL_SIZE + 8 + Xoffset + 1;
          this.cursor.y = (yIdx + 1) * MAP_CELL_SIZE + 8 + Yoffset + 1;
        },
      });
      SoundPlayer.clickSFX(this, 0.75);
    } else if (
      input.isJustPressedLeft &&
      this.board[this.currentChunk]?.[xIdx - 1]?.[yIdx]
    ) {
      this.add.tween({
        targets: this.cursor,
        x: `-=${MAP_CELL_SIZE}`,
        yoyo: false,
        duration: GAME_VARIABLES.MOVE_TIME_MS - 20,
        repeat: 0,
        onComplete: () => {
          this.cursor.x = (xIdx - 1) * MAP_CELL_SIZE + 8 + Xoffset + 1;
          this.cursor.y = yIdx * MAP_CELL_SIZE + 8 + Yoffset + 1;
        },
      });
      SoundPlayer.clickSFX(this, 0.75);
    } else if (
      input.isJustPressedRight &&
      this.board[this.currentChunk]?.[xIdx + 1]?.[yIdx]
    ) {
      this.add.tween({
        targets: this.cursor,
        x: `+=${MAP_CELL_SIZE}`,
        yoyo: false,
        duration: GAME_VARIABLES.MOVE_TIME_MS - 20,
        repeat: 0,
        onComplete: () => {
          this.cursor.x = (xIdx + 1) * MAP_CELL_SIZE + 8 + Xoffset + 1;
          this.cursor.y = yIdx * MAP_CELL_SIZE + 8 + Yoffset + 1;
        },
      });
      SoundPlayer.clickSFX(this, 0.75);
    } else if (input.isJustPressedAction) {
      if (this.board[this.currentChunk]?.[xIdx][yIdx]?.data?.locked) {
        return;
      }
      if (this.board[this.currentChunk]?.[xIdx][yIdx]?.data?.levelKey) {
        DatabaseHandle.getLevel(
          this.board[this.currentChunk][xIdx][yIdx].data.levelKey
        ).then((data: any) => {
          this.scene.transition({
            target: `${SceneName.StartScene}-worldmap-${counter}`,
            data: {
              tilemapKey: data._id,
              entities: data.entities,
            },
            moveBelow: true,

            duration: 10,
          });
        });
      }
    }
  }
}
